import React, { useState } from "react";
import { Transition } from "@headlessui/react";

const Accordion = ({ title, content }) => {
  const [isActive, setIsActive] = useState(false);

  return (
    <div className="w-full">
      <div
        className="flex items-center py-2"
        onClick={() => setIsActive(!isActive)}
      >
        <div>
          {isActive ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M5 15l7-7 7 7"
              />
            </svg>
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9 5l7 7-7 7"
              />
            </svg>
          )}
        </div>
        <div className="py-4 font-semibold ml-4">{title}</div>
      </div>
      <Transition
        appear={true}
        show={isActive}
        enter="transform transition duration-500"
        enterFrom="opacity-30 scale-80 translate-y-5"
        enterTo="opacity-100 scale-100 translate-y-0"
        leave="transform duration-600 transition ease-in-out"
        leaveFrom="opacity-100 scale-100"
        leaveTo="opacity-0 scale-95 "
      >
        {isActive && <div className="mb-4 ml-10">{content}</div>}
      </Transition>
      <hr />
    </div>
  );
};

export default Accordion;
